import React from "react";
import { Menu } from "antd";
import {
  AppstoreOutlined,
  WalletOutlined,
  AreaChartOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
//import { Link } from "react-router-dom";
import "../styles/Sidebar.css"; // Ensure CSS path is correct

const Sidebar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="sidebar">
      <Menu
        mode="inline"
        theme="light"
        defaultSelectedKeys={["1"]}
        style={{ height: "100%" }}
        onClick={({ key }) => navigate(key)} // Use key to navigate to the correct route
      >
        <Menu.Item key="/dashboard/projects" icon={<AppstoreOutlined />}>
          Projects
        </Menu.Item>
        <Menu.Item key="/dashboard/chainlist" icon={<WalletOutlined />}>
          Chains List
        </Menu.Item>
        <Menu.Item key="/dashboard/statistics" icon={<AreaChartOutlined />}>
          Statistics
        </Menu.Item>
        <Menu.Item key="/dashboard/promotions" icon={<SettingOutlined />}>
          Promotions
        </Menu.Item>
        <Menu.Item key="/dashboard/settings" icon={<SettingOutlined />}>
          Settings
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default Sidebar;
